import { render, staticRenderFns } from "./ModalAddRole.vue?vue&type=template&id=555a5599&"
import script from "./ModalAddRole.vue?vue&type=script&lang=js&"
export * from "./ModalAddRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports